// DO NOT MODIFY, this file is autogenerated by tools/build.ts
import { ɵzoneWrap } from '@angular/fire';
import {
  collection as _collection,
  collectionData as _collectionData,
  doc as _doc,
  docData as _docData,
  snapToData as _snapToData,
  fromRef as _fromRef
} from 'rxfire/firestore/lite';

export const collectionSnapshots = ɵzoneWrap(_collection, true);
export const collectionData = ɵzoneWrap(_collectionData, true);
export const docSnapshots = ɵzoneWrap(_doc, true);
export const docData = ɵzoneWrap(_docData, true);
export const snapToData = ɵzoneWrap(_snapToData, true);
export const fromRef = ɵzoneWrap(_fromRef, true);
